module.exports = __webpack_public_path__ + "img/logo-color.d44998fe.svg";